//
import validate from 'validate.js'

/**
 *
 */
export default function(val) {
    
    return !isNaN(val) || 'Este campo debe ser numérico.'
}
